import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { stage, Stage } from './Constants/constants';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...(stage === Stage.DEV ? {} : {fallbackLng: 'en'}),
    //lng: 'th', // Set the default language here
    react: {
      useSuspense: true // Wait for translations to load before rendering
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });


export default i18n;